import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'
import { roundLngLat } from '@shared/shared.utils'

type Option = {
  label: string
  value: number | string
}
@Component({
  selector: 'lng-lat-fields',
  templateUrl: './lng-lat-fields.component.html',
  styleUrls: ['./lng-lat-fields.component.css'],
})
export class LngLatFieldsComponent implements OnInit {
  @Input() public lat: any
  @Input() public lng: any
  @Input() public latError: any
  @Input() public lngError: any
  @Input() public isReadonly: boolean

  @Output() public onLatChange: EventEmitter<any> = new EventEmitter()
  @Output() public onLngChange: EventEmitter<any> = new EventEmitter()

  constructor() {}

  ngOnInit() {}

  handleCoordinatesPick([lng, lat]) {
    this.onLngChange.emit(roundLngLat(lng))
    this.onLatChange.emit(roundLngLat(lat))
  }

  handleLatChange(value: any) {
    this.onLatChange.emit(!!value ? roundLngLat(parseFloat(value)) : '')
  }

  handleLngChange(value: any) {
    this.onLngChange.emit(!!value ? roundLngLat(parseFloat(value)) : '')
  }
}
